import { LocalizedPageTitle, LocalizedParagraph } from '@mews-commander/ui';
import { LocalizedText, MEWS_CONTACT_US_URL } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body, Link, Pictogram, Stack } from '@optimus-web/core';
import { use2FAEmailCode } from '../../../Configure2FA';

export const TwoFactorAuthenticationEmailLink = () => {
    const { sendTwoFactorEmailLink } = use2FAEmailCode();

    return (
        <Stack spacing="500" vertical>
            <Pictogram value="email" size="large" />
            <Stack spacing="300" vertical>
                <Stack spacing="100" vertical>
                    <LocalizedPageTitle textKey={TextKey.CheckYourEmail} />
                    <LocalizedParagraph textKey={TextKey.TwoFactorAuthenticationVerifyEmailLinkDescription} />
                    <Link onClick={sendTwoFactorEmailLink}>
                        <LocalizedText textKey={TextKey.ResendEmail} />
                    </Link>
                </Stack>
                <Body size="small" variant="secondary">
                    <LocalizedText
                        substitutes={{
                            contactUsHere: (
                                <Link href={MEWS_CONTACT_US_URL} variant="basic">
                                    <LocalizedText textKey={TextKey.ContactUsHere} />
                                </Link>
                            ),
                        }}
                        textKey={TextKey.NoTwoFactorEmailCodeInstructions}
                    />
                </Body>
            </Stack>
        </Stack>
    );
};
